import Renderer from "@FreeRider/Renderers/Renderer";
import MountainBikeRenderer from '@FreeRider/Renderers/MountainBikeRenderer';
import Player from '@FreeRider/Player/Player';
import MountainBike from '@FreeRider/Player/Vehicles/MountainBike';
import Camera from '@FreeRider/Camera';
import Screen from '@FreeRider/Screen';

class PlayerRenderer extends Renderer
{
    private mountainBikeRenderer: MountainBikeRenderer;

    /**
     * Constructor
     * @param canvas
     */
    constructor(canvas: HTMLCanvasElement)
    {
        super(canvas);
        this.mountainBikeRenderer = new MountainBikeRenderer(canvas);
    }

    /**
     * Render
     * @param player
     * @param camera
     * @param screen
     */
    public render(player: Player, camera: Camera, screen: Screen)
    {
        if (player.vehicle instanceof MountainBike)
        {
            this.mountainBikeRenderer.render(player, camera, screen);
        }

    }
}

export default PlayerRenderer;